module.exports = __webpack_public_path__ + "img/focus-profiles.500861e6.png";